// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__APuey","alertIcon":"ConfirmModal_alertIcon__3npwf"};